import { AUTH_TOKEN_KEY } from "../config";

/**
 * Get the current authentication token
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

/**
 * Set the authentication token
 * @param token The JWT token to set
 */
export const setAuthToken = (token: string): void => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

/**
 * Clear the authentication token
 */
export const clearAuthToken = (): void => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

/**
 * Check if the user is authenticated
 */
export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};

// Development authentication setup
export const setupDevelopmentAuth = () => {
  if (process.env.NODE_ENV === 'development') {
    const debugToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiYzZjNmI2NzgtZGM1Yy00NjkzLTlhNmUtZDIyZTFiOTdkZDA1IiwiZW1haWwiOiJhZG1pbkBleGFtcGxlLmNvbSIsInVzZXJuYW1lIjoiYWRtaW4iLCJyb2xlIjoiYWRtaW4iLCJzdG9yZV90eXBlIjpudWxsLCJleHAiOjE3NDc4MzU1MTd9.V4Fhu8AExVHPPWEBwyxpCzhQQ2eRMsgoSL-PZTaf1oU";
    
    // Set the debug token in localStorage
    localStorage.setItem(AUTH_TOKEN_KEY, debugToken);
    console.log('🔧 Development auth token set');
    
    return true;
  }
  return false;
};

// Check if we need to setup development auth
export const ensureDevelopmentAuth = () => {
  if (process.env.NODE_ENV === 'development' && !getAuthToken()) {
    return setupDevelopmentAuth();
  }
  return !!getAuthToken();
};

export default {
  getAuthToken,
  setAuthToken,
  clearAuthToken,
  isAuthenticated
}; 